"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lastFocusableOf = exports.focusFirstElementOf = exports.focus = exports.firstFocusableOf = exports.emitFocusListBoxItem = exports.emitFocusListBox = exports.TYPE_ITEM = exports.FOCUS_LISTBOX = void 0;
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _first = _interopRequireDefault(require("lodash/fp/first"));
var _last = _interopRequireDefault(require("lodash/fp/last"));
var _dom = require("@active/react-utils/dom");
var FOCUS_LISTBOX = exports.FOCUS_LISTBOX = 'focus-listbox';
var TYPE_ITEM = exports.TYPE_ITEM = 'item';
var emitFocusListBox = exports.emitFocusListBox = function emitFocusListBox(type) {
  return function (element) {
    element === null || element === void 0 || element.dispatchEvent(new CustomEvent(FOCUS_LISTBOX, {
      bubbles: false,
      cancelable: false,
      detail: type
    }));
    return element;
  };
};
var emitFocusListBoxItem = exports.emitFocusListBoxItem = emitFocusListBox(TYPE_ITEM);
var focus = exports.focus = function focus(element) {
  return element === null || element === void 0 ? void 0 : element.focus({
    preventScroll: true
  });
};
var firstFocusableOf = exports.firstFocusableOf = (0, _compose["default"])(_first["default"], (0, _dom.tabbable)({
  displayCheck: 'none'
}));
var focusFirstElementOf = exports.focusFirstElementOf = (0, _compose["default"])(focus, firstFocusableOf);
var lastFocusableOf = exports.lastFocusableOf = (0, _compose["default"])(_last["default"], (0, _dom.tabbable)({
  displayCheck: 'none'
}));